export const ROUTE_HOME = "/";
export const ROUTE_LOGIN = "/login";
export const ROUTE_LOGOUT = "/logout";
export const ROUTE_USERS = "/users";
export const ROUTE_USER_ADD = "/users/add";
export const ROUTE_USER = "/users/:name";
export const ROUTE_USER_EDIT = "/users/:name/edit";
export const ROUTE_USER_PASSWORD = "/users/change-password";
export const ROUTE_USER_EDITS = "/users/:name/edits";
export const ROUTE_USER_MY_FINGERPRINTS = "/users/fingerprints";
export const ROUTE_PERFORMER = "/performers/:id";
export const ROUTE_PERFORMER_ADD = "/performers/add";
export const ROUTE_PERFORMER_EDIT = "/performers/:id/edit";
export const ROUTE_PERFORMER_MERGE = "/performers/:id/merge";
export const ROUTE_PERFORMER_DELETE = "/performers/:id/delete";
export const ROUTE_PERFORMERS = "/performers";
export const ROUTE_SCENE = "/scenes/:id";
export const ROUTE_SCENE_ADD = "/scenes/add";
export const ROUTE_SCENE_EDIT = "/scenes/:id/edit";
export const ROUTE_SCENE_DELETE = "/scenes/:id/delete";
export const ROUTE_SCENE_FINGERPRINT_CLUSTERS = "/scenes/:id/fingerprints";
export const ROUTE_SCENES = "/scenes";
export const ROUTE_STUDIO = "/studios/:id";
export const ROUTE_STUDIO_ADD = "/studios/add";
export const ROUTE_STUDIO_EDIT = "/studios/:id/edit";
export const ROUTE_STUDIO_DELETE = "/studios/:id/delete";
export const ROUTE_STUDIOS = "/studios";
export const ROUTE_TAG = "/tags/:id";
export const ROUTE_TAG_ADD = "/tags/add";
export const ROUTE_TAG_MERGE = "/tags/:id/merge";
export const ROUTE_TAG_EDIT = "/tags/:id/edit";
export const ROUTE_TAG_DELETE = "/tags/:id/delete";
export const ROUTE_TAGS = "/tags";
export const ROUTE_CATEGORY = "/categories/:id";
export const ROUTE_CATEGORY_ADD = "/categories/add";
export const ROUTE_CATEGORY_EDIT = "/categories/:id/edit";
export const ROUTE_CATEGORIES = "/categories";
export const ROUTE_EDITS = "/edits";
export const ROUTE_EDIT = "/edits/:id";
export const ROUTE_EDIT_UPDATE = "/edits/:id/update";
export const ROUTE_EDIT_AMEND = "/edits/:id/amend";
export const ROUTE_REGISTER = "/register";
export const ROUTE_ACTIVATE = "/activate";
export const ROUTE_FORGOT_PASSWORD = "/forgot-password";
export const ROUTE_RESET_PASSWORD = "/reset-password";
export const ROUTE_CONFIRM_EMAIL = "/users/confirm-email";
export const ROUTE_CHANGE_EMAIL = "/users/change-email";
export const ROUTE_SEARCH = "/search";
export const ROUTE_VERSION = "/version";
export const ROUTE_SITE = "/sites/:id";
export const ROUTE_SITE_ADD = "/sites/add";
export const ROUTE_SITE_EDIT = "/sites/:id/edit";
export const ROUTE_SITES = "/sites";
export const ROUTE_SITE_CATEGORY = "/site-categories/:id";
export const ROUTE_SITE_CATEGORY_ADD = "/site-categories/add";
export const ROUTE_SITE_CATEGORY_EDIT = "/site-categories/:id/edit";
export const ROUTE_SITE_CATEGORIES = "/site-categories";
export const ROUTE_DRAFT = "/drafts/:id";
export const ROUTE_DRAFTS = "/drafts";
export const ROUTE_NOTIFICATIONS = "/notifications";
export const ROUTE_NOTIFICATION_SUBSCRIPTIONS = "/users/:name/notifications";
export const ROUTE_AUDITS = "/audits";
